import React from 'react';
import './Advantages.css';
import advantagesImg from '../Images/cric2.png'; // Use your desired image

const advantages = [
  {
    title: "Comprehensive Payment Handling",
    desc: "Easily manage a wide range of payments including DTH/Cable TV, Electricity, Broadband/Landline, Postpaid Mobile, Water, Piped Gas, Education, FASTag Recharge, Credit Cards, Municipal Tax, and Insurance."
  },
  {
    title: "Effective Expense Management",
    desc: "Utilize our user-friendly payment gateway service to stay updated and manage your expenses efficiently."
  },
  {
    title: "Accessible Support",
    desc: "For any assistance, reach out to our support team through the 'Contact Support' option in the app."
  },
  {
    title: "Proactive Notifications",
    desc: "Our dedicated support team will keep you informed with in-app notifications at every step of the way."
  }
];

const Advantages1 = () => (
  <section className="advantages-section" id="advantages">
    <div className="advantages-container">
      <div className="advantages-info">
        <h2 className="advantages-title">Advantages</h2>
        <h4 className="advantages-subtitle">Why Choose RingPe ?</h4>
        <ul className="advantages-list">
          {advantages.map((a, idx) => (
            <li key={idx} className="advantage-item">
              <h3>{a.title}</h3>
              <p>{a.desc}</p>
            </li>
          ))}
        </ul>
      </div>
      <div className="advantages-image">
        <img src={advantagesImg} alt="Advantages" />
      </div>
    </div>
  </section>
);

export default Advantages1;